import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReplyComponent } from './reply.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeaderModule } from './components/header/header.module';
import { NavBarModule, SurveyTitleModule, SurveyDataResolve, ReplyDataResolve, TimeDataResolve } from '../shared';

import { 
  QuestionRadioModule,
  QuestionCheckboxModule,
  QuestionTextModule,
  QuestionTableCheckboxModule,
  QuestionAfterschoolModule,
} from './components/questions';

import { LoadingModule } from '@schoolbelle/common/loading';

import { DialogModule } from '@schoolbelle/common/dialog';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,

    // NavBarModule,
    LoadingModule.forRoot(),
    DialogModule,
    SurveyTitleModule,

    HeaderModule,
    QuestionRadioModule,
    QuestionCheckboxModule,
    QuestionTextModule,
    QuestionTableCheckboxModule,
    QuestionAfterschoolModule,
  ],
  declarations: [ReplyComponent],
  providers: [SurveyDataResolve, ReplyDataResolve, TimeDataResolve],
  exports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,

    // NavBarModule,
    LoadingModule,
    DialogModule,
    SurveyTitleModule,

    HeaderModule,
    QuestionRadioModule,
    QuestionCheckboxModule,
    QuestionTextModule,
    QuestionTableCheckboxModule
  ]
})
export class ReplyModule {}
